const BASE_DATE = "1970-01-01T"

export function isoToTime(iso: string | null | undefined): string | null {
  if (!iso) return null
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) {
    return null
  }
  const hours = `${date.getUTCHours()}`.padStart(2, "0")
  const minutes = `${date.getUTCMinutes()}`.padStart(2, "0")
  return `${hours}:${minutes}`
}

export function timeToIso(time: string): string {
  const [hours, minutes] = time.split(":")
  const hh = `${parseInt(hours ?? "0", 10)}`.padStart(2, "0")
  const mm = `${parseInt(minutes ?? "0", 10)}`.padStart(2, "0")
  return `${BASE_DATE}${hh}:${mm}:00Z`
}

export function parseQuietHours(
  value: Record<string, string | null> | string | null | undefined,
): { enabled: boolean; start: string; end: string } {
  if (!value) {
    return { enabled: false, start: "21:00", end: "07:00" }
  }

  if (typeof value === "string") {
    let trimmed = value
    if (trimmed.startsWith("[") || trimmed.startsWith("(")) {
      trimmed = trimmed.slice(1)
    }
    if (trimmed.endsWith("]") || trimmed.endsWith(")")) {
      trimmed = trimmed.slice(0, -1)
    }
    const [startRaw, endRaw] = trimmed.split(",")
    const start = isoToTime(startRaw?.trim() ?? null) ?? "21:00"
    const end = isoToTime(endRaw?.trim() ?? null) ?? "07:00"
    return { enabled: true, start, end }
  }

  const start = isoToTime(value.start ?? null) ?? "21:00"
  const end = isoToTime(value.end ?? null) ?? "07:00"
  const enabled = Boolean(value.start || value.end)
  return { enabled, start, end }
}

export function buildQuietHoursPayload(
  enabled: boolean,
  start: string,
  end: string,
): Record<string, string> | null {
  if (!enabled) return null
  return {
    start: timeToIso(start),
    end: timeToIso(end),
  }
}
